<script lang="ts">
    import TreeBackground from "./TreeBackground.svelte";
</script>

<!-- <img src="/static/front_images/fast2.jpg" /> -->
<main>
    <TreeBackground />
    <img class="logo" src="/static/logo.svg" alt="Fjälltoppens logga" />
    <div class="description">
        <h2>Om Fjälltoppen</h2>
        <p>Hej! Vad roligt att du hittat hit!</p>
        <p>
            Vi är två <strike>eld</strike>snösjälar som skapat <a href="https://www.fjälltoppen.se">fjälltoppen.se</a> för
            att göra det enklare att hitta rätt bland Sveriges alla fantastiska skidorter.
        </p>
        <p>
            I vårt avlånga land finns det många härliga ställen att åka skidor, men vilket fjäll som är "det bästa"
            varierar mycket från person till person.
        </p>
        <p>
            Vissa har åkt skidor i åratal och vill ha de brantaste backarna och den svåraste offpisten, medan andra är
            nybörjare och föredrar lättare åkning. Somliga vill varva den alpina åkningen med längdskidor, medan andra
            tycker att det viktigaste inte är själva skidåkningen utan afterskin.
        </p>
        <p>Oavsett vad som är viktigt för dig så tror vi att det finns en skidort som passar dig!</p>

        <h2>Samarbeten</h2>
        <p>Vi är alltid öppna för samarbeten så om du har någon idé så skicka oss ett meddelande via länken nedan!</p>
    </div>

    <a class="contact-us" href="mailto:contact@optimeringsfabriken.se"> Kontakta oss </a>
</main>

<svelte:head>
    <title>Om oss - Fjälltoppen</title>
</svelte:head>

<style>
    main {
        display: flex;
        align-items: center;
        width: 100%;
        flex-direction: column;
    }

    .logo {
        max-width: 400px;
        margin-top: 32px;
    }

    .description {
        max-width: 500px;
    }

    .contact-us {
        border: none;
        color: white;
        background: #0c54a2;
        padding: 20px 30px;
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 100px;
        border-radius: 6px;
        transition: box-shadow 150ms ease-out, background-color 150ms ease-out;
    }

    .contact-us:hover {
        background-color: rgb(5, 63, 126);
    }

    @media (max-width: 800px) {
        .logo {
            max-width: 250px;
        }

        .description {
            max-width: 300px;
        }

        .contact-us {
            padding: 15px 20px;
            font-size: 16px;
        }
    }
</style>
